"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let DataSetModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.datas = new Array();
    this.total = 0;
  }
};
DataSetModel.model = "data.set";
DataSetModel = __decorateClass([
  Annotation.ModelMeta
], DataSetModel);
